import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { SsoComponent } from './sso/sso.component';
import { OauthComponent } from './oauth/oauth.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { AccountClosedComponent } from './account-closed/account-closed.component';
import { AccountSuspComponent } from './account-susp/account-susp.component';
import { AccountHoldComponent } from './account-hold/account-hold.component';
import { OauthAppComponent } from './oauth-app/oauth-app.component';
import { AuthLayoutComponent } from '../layout/auth-layout/auth-layout.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserInviteConsentComponent } from './user-invite-consent/user-invite-consent.component';
import { LegacyUserInviteConsentComponent } from './legacy-user-invite-consent/legacy-user-invite-consent.component';
import { EmailChangeVerifyComponent } from './email-change-verify/email-change-verify.component';

const routes: Routes = [
  { path: '', component: AuthLayoutComponent, children : [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'oauth', component: OauthComponent },
    { path: 'oauth-app', component: OauthAppComponent },
    { path: 'sso', component: SsoComponent },
    { path: 'forgotpassword', component: ForgotPasswordComponent },
    { path: 'passwordhint', redirectTo: 'forgotpassword'},
    { path: 'passwordreset/:cachekey', component: PasswordResetComponent },
    { path: 'account-closed', component: AccountClosedComponent },
    { path: 'account-suspended', component: AccountSuspComponent },
    { path: 'accounting-hold', component: AccountHoldComponent },
    { path: 'verifyemail', component: VerifyEmailComponent },
    { path: 'setinvitepassword', component: ResetPasswordComponent },
    { path: 'setuserinviteconsent', component: UserInviteConsentComponent },
    { path: 'setlegacyuserinvitecontent', component: LegacyUserInviteConsentComponent },
    { path: 'emailchange', component: EmailChangeVerifyComponent },
    { path: 'verifychangedemail', redirectTo: 'emailchange' },
  ] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
